import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { CommonService } from 'fccore2';
import { FcModalConfig } from '../business/fcmodel.business';
import { FcEvent } from '../business/fcevent.event';
import { FcComponent } from '../fc';
/**
 * fc-modalcardå¡çæ¨¡ææ¡
 * 
 * æ¨¡ææ¡ä¸­å¯ä»¥åµå¥ä»»ä½ç»ä»¶ã
 * 
 * å½æ¨¡ææ¡éè¦åµå¥ç»ä»¶æ¶ã
 * 
 * äºä»¶ï¼
 * 
 * 1.ç¡®å®äºä»¶ï¼okFunc
 * 
 * 2.åæ¶äºä»¶ï¼cancelFunc
 * 
 */
@Component({
    selector: 'fc-modalcard',
    template: ` 
        <ng-template #template>
            <ng-content select="[fccontent]">
            </ng-content> 
        </ng-template>
        <ng-template #templateFooter>
            <ng-content select="[fcfooter]">
            </ng-content> 
        </ng-template>
        <span (click)="openTemplateDialog(template);">
            <ng-content select="[fcopen]"></ng-content>
        </span>
    `,
    styles: [`
    `]
})
export class FcmodalcardComponent extends FcComponent {
    @Input()
    fcVisiable = true;
    @ViewChild("template", {static: false})
    template: ElementRef;
    @ViewChild("templateFooter", {static: false})
    templateFooter: ElementRef;
    @Input()
    fcToken: string;
    /**æ é¢*/
    @Input()
    fcTitle: string;
    /**å®½åº¦*/
    @Input()
    fcWidth: string;
    /**åºé¨*/
    @Input()
    fcFooter: any;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-modalcard');
    }

    ngOnInit() {
        if (this.fcToken) {
            this.pushDestroy(CommonService.subscribe(this.fcToken + '-opened', (param) => {
                this.fcVisiable = true;
                this.openTemplateDialog(this.template, param);
            }))
        }
    }
    /**
     * æå¼å¼¹çªç»ä»¶
     * @param template 
     */
    openTemplateDialog(template: any, param?: any) {
        if (!param) {
            param = {
                param: {

                }
            }
        }
        let modal: FcModalConfig = {
            mask:param.param.mask,
            title: param.param.fcTitle || this.fcTitle,
            closable: param.param.fcClosable || true,
            className: param.param.fcClassName || '',
            content: template,
            width: this.fcWidth || param.param.fcWidth || '80%',
            footer: this.templateFooter || null,
            okFunc: (result) => {
                /**ç¡®å®äºä»¶*/
                this.event('okFunc', result);
            },
            cancelFunc: (result) => {
                /**åæ¶äºä»¶*/
                this.event('cancelFunc', result);
            },
            token: this.fcToken
        }
        CommonService.event(FcEvent.fcmodal.component, modal);
    }
    ngOnDestroy() {
        CommonService.clearEmmitByKey(this.fcToken + '-opened');
    }
}
